var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"app"}},[_c('link',{attrs:{"href":"https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css","rel":"stylesheet"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }